@if (isOpen) {
  <div class="popup" (click)="closePopup()">
    <div class="popup-content">
      <span class="close-btn" (click)="closePopup()">×</span>
      <div id="main" (click)="$event.stopPropagation()">
        <mat-dialog-content>
          <div class="top-row">
            @if (selectedAsset.assetTypeClassification === 0) {
              <img
                src="/img/RoRo.png"
                class="asset-icon"
                />
            }
            @if (selectedAsset.assetTypeClassification === 1) {
              <img
                src="/img/Skip.png"
                class="asset-icon"
                />
            }
            @if (containers?.length && containers?.length > 1) {
              <mat-form-field id="selectList" appearance="fill" class="dropdown">
                <mat-label>Select</mat-label>
                <mat-select [(value)]="selectedId" (selectionChange)="onAssetChange($event)">
                  @for (container of containers; track container) {
                    <mat-option [value]="container.containerName">
                      {{ (container.containerName + " (" + container.containerType) + ")" }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>
            }
          </div>
          <div class="info-grid">
            <div class="info-cell">
              <span class="label">ID</span>
              <span>{{ selectedAsset.containerName }}</span>
            </div>
            <div class="info-cell">
              <span class="label">Type</span>
              <span>{{ selectedAsset.containerType }}</span>
            </div>
            <div class="info-cell">
              <span class="label">On Site</span>
              <span>{{ selectedAsset.daysOnSiteDisplay }}</span>
            </div>
            <div class="info-cell">
              <span class="label">Status</span>
              <span>{{ selectedAsset.statusDisplay }}</span>
            </div>
            @if (selectedAsset.externalReference || selectedAsset.wasteTypeName) {
              <div class="info-cell">
                <span class="label">Contract</span>
                <span>{{ selectedAsset.externalReference }}</span>
              </div>
            }
            @if (selectedAsset.externalReference || selectedAsset.wasteTypeName) {
              <div class="info-cell">
                <span class="label">Waste</span>
                <span>{{ selectedAsset.wasteTypeName }}</span>
              </div>
            }
          </div>
        </mat-dialog-content>
      </div>
      <br>
        <div id="image">
          <img [src]="selectedAsset.assetURL ?? imageSrc" alt="Popup Image" />
        </div>
      </div>
    </div>
  }
